import * as React from "react";
import { forwardRef } from "react";
const SvgBars = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M13 15.2546H6.06445V18.5061C6.06445 20.163 7.4076 21.5061 9.06445 21.5061H10C11.6569 21.5061 13 20.163 13 18.5061V15.2546Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M4.06445 8.92358H8.06445L7.1198 5.92358H5.0091L4.06445 8.92358Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M9.53223 15.2546V10.9236C9.53223 9.81901 8.6368 8.92358 7.53223 8.92358H4.59668C3.49211 8.92358 2.59668 9.81901 2.59668 10.9236V19.5857C2.59668 20.6903 3.49211 21.5857 4.59668 21.5857H9.0683",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M15.2266 21.4615H18.5916",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M21.2388 12.1158C21.3589 12.0003 21.3948 11.8268 21.3298 11.676C21.2647 11.5252 21.1115 11.4268 20.9415 11.4267H12.8773C12.7073 11.4268 12.5541 11.5252 12.489 11.676C12.424 11.8268 12.4599 12.0003 12.5801 12.1158L16.9097 16.2723L21.2388 12.1158Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M16.9092 21.3456L16.9092 16.2723",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M18.0591 11.4267L20.6073 8.87851",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M18.0596 11.4268L20.6078 8.87863",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M3.56445 5.92358H8.56445",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}));
const ForwardRef = forwardRef(SvgBars);
export default ForwardRef;
